module.exports = __webpack_public_path__ + "img/dashboard_blue.301bda88.svg";